import winston from 'winston';

const LogLevel = Object.freeze({
        ERROR: {
                name: 'ERROR',
                level: winston.config.npm.levels.error,
        },
        WARN: {
                name: 'WARN',
                level: winston.config.npm.levels.warn,
        },
        INFO: {
                name: 'INFO',
                level: winston.config.npm.levels.info,
        },
        DEBUG: {
                name: 'DEBUG',
                level: winston.config.npm.levels.debug,
        },
});

export default LogLevel;
